module.exports = __webpack_public_path__ + "assets/img/img191.99979ac1.png";